/**
 * Poster attribution tracker.
 *
 * When a visitor lands with ?utm_campaign=li-<slug>, capture the slug in
 * sessionStorage and POST a "visit" event to /api/analytics/poster.
 * On successful signup, we POST a "signup" event with the same slug so
 * the admin dashboard can compute per-poster conversion.
 */
import { api } from "./api";

const KEY = "cap_utm_campaign";
const VALID = new Set(["copilot", "boardpack", "pilot", "cockpits", "referral"]);

export function captureUtm() {
  try {
    const u = new URL(window.location.href);
    const raw = u.searchParams.get("utm_campaign");
    if (!raw) return;
    const slug = raw.replace(/^li-/, "");
    if (!VALID.has(slug)) return;
    // Idempotent per session — only fire once per landing
    const already = sessionStorage.getItem(KEY);
    sessionStorage.setItem(KEY, slug);
    if (already === slug) return;
    const referrer = document.referrer || "";
    // fire and forget
    api.trackPoster({ slug, kind: "visit", referrer }).catch(() => {});
  } catch { /* noop */ }
}

export function trackPosterSignup(email) {
  try {
    const slug = sessionStorage.getItem(KEY);
    if (!slug || !VALID.has(slug)) return;
    api.trackPoster({ slug, kind: "signup", email }).catch(() => {});
  } catch { /* noop */ }
}
